<template>
	<div class="home">
		<div class="swiper-container swiper1">
			<div class="swiper-wrapper">

				<div class="swiper-slide">
					<img src="../assets/image/banner.jpg" alt="轮播" class="banner">
				</div>
				<div class="swiper-slide">
					<img src="../assets/image/banner9.jpg" alt="轮播" class="banner">
				</div>
				<!-- 
				<div class="swiper-slide">
					<img src="../assets/image/banner6.jpg" alt="轮播" class="banner">
				</div> -->

				<div class="swiper-slide">
					<img src="../assets/image/banner8.jpg" alt="轮播" class="banner">
				</div>

				<div class="swiper-slide">
					<img src="../assets/image/banner7.jpg" alt="轮播" class="banner">
				</div>
				<div class="swiper-slide">
					<img src="../assets/image/banner4.jpg" alt="轮播" class="banner">
				</div>
			</div>
			<!-- 如果需要分页器 -->
			<div class="swiper-pagination"></div>
		</div>
		<!-- 滚动证书 -->
		<div>
			<div class="contanier">
				<div class="section-title">
					<h2>荣誉资质</h2>
					<p>荣誉不只是对我们的肯定，更是继续前进的动力</p>
				</div>
				<certs></certs>
			</div>
		</div>
		<!-- 公司简介 -->
		<div class="contanier">
			<div class="section-title">
				<h2>公司简介</h2>
				<p>让您更好了解我们，携手共创美好未来</p>
			</div>
			<div class="desc-box">
				<div class="dec-img">
					<img src="../assets/image/g-1.jpg" alt="" class="banner">
				</div>
				<div class="dec-info">
					<h3>粤之彩印刷 • 深圳</h3>
					<div>
						深圳市粤之彩印刷有限公司创立于2003年8月份，注册资本5000万元人民币，
						拥有6000平方米厂房，是一家高科技数字印刷设备为依托的现代化印刷企业。
						<br>
						<br>
						我们拥有德国海德堡CTP印前制版及印前波拉裁切系统、印刷标准化色彩管理系统、
						印后折页无缝数据标准化管理系统；德国海德堡对开四色、海德堡四开四色、海德堡对开双色机、
						海德堡对开单色机等15个印刷单元；印后德国海德堡波拉切纸机、海德堡折页机、海德堡全梳万能折页机、
						马天尼骑订龙、马天尼胶装龙、马天尼锁线机等全套高性能设备。
						<br>
						<br>
						我们可以实现从排版、设计、制版、印刷、折页、装订一条龙生产服务。我们的业务印刷范围覆盖：摄影画册、书刊、
						企业宣传、产品、宣传海报、产品说明书、手提袋纸袋、展会物料等众多以教育领域产品印刷为主。尤其是在宣传册印刷方面，我们有自己近二十年积累了独特的见解......
					</div>
					<router-link to="/about" class="more-btn">了解更多++</router-link>
				</div>
			</div>
		</div>

		<!-- 品牌优势 -->
		<div class="advatage">
			<div class="contanier">
				<div class="section-title">
					<h2>品牌优势</h2>
					<p>强大的生产实力，突出的行业优势</p>
				</div>
				<div class="adv-table">
					<h3 class="adv-title">先进设备管理 品质认证保障</h3>
					<ul>
						<li>
							<h3>环保原料</h3>
							<div class="adv-info">环保型原辅料严格筛选 <br>健全的品控流程</div>
							<div class="adv-img">
								<img src="../assets/image/g-3.jpg" alt="">
							</div>
						</li>
						<li>
							<h3>印刷设备</h3>
							<div class="adv-info">先进设备、定期维护 <br>金牌技师，优质耗材</div>
							<div class="adv-img">
								<img src="../assets/image/g-4.jpg" alt="">
							</div>
						</li>
						<li>
							<h3>装订系统</h3>
							<div class="adv-info">全套后期加工设备 <br>优质快捷</div>
							<div class="adv-img">
								<img src="../assets/image/g-5.jpg" alt="">
							</div>
						</li>
						<li>
							<h3>品质认证</h3>
							<div class="adv-info">实用新型专利证书、中国环境标志产品认证证书 政府机关定点采购单位</div>
							<div class="adv-img">
								<img src="../assets/image/g-6.jpg" alt="">
							</div>
						</li>
					</ul>
				</div>
				<h3 class="adv-xj">把握每一个细节 完美呈现</h3>
				<div class="xj-ifo">从领机开机印刷到装订打包，小到纸张裁切，每一个环节我们都严格要求自己，保证每一件印品都完美无瑕</div>
				<ul class="xj-list">
					<li>
						<div class="xj-img">
							<img src="../assets/image/s-1a.png" alt="">
						</div>
						<div class="xj-desc">图像优化<br>色彩管理</div>
						<div class="xj-sort">-01-</div>
					</li>
					<li>
						<div class="xj-img">
							<img src="../assets/image/s-2a.png" alt="">
						</div>
						<div class="xj-desc">数码打样</div>
						<div class="xj-sort">-02-</div>
					</li>
					<li>
						<div class="xj-img">
							<img src="../assets/image/s-3a.png" alt="">
						</div>
						<div class="xj-desc">制版印刷</div>
						<div class="xj-sort">-03-</div>
					</li>
					<li>
						<div class="xj-img">
							<img src="../assets/image/s-4a.png" alt="">
						</div>
						<div class="xj-desc">毛品检查</div>
						<div class="xj-sort">-04-</div>
					</li>
					<li>
						<div class="xj-img">
							<img src="../assets/image/s-5a.png" alt="">
						</div>
						<div class="xj-desc">后期装订</div>
						<div class="xj-sort">-05-</div>
					</li>
					<li>
						<div class="xj-img">
							<img src="../assets/image/s-6a.png" alt="">
						</div>
						<div class="xj-desc">成品检查</div>
						<div class="xj-sort">-06-</div>
					</li>
					<li>
						<div class="xj-img">
							<img src="../assets/image/s-7a.png" alt="">
						</div>
						<div class="xj-desc">安排送货</div>
						<div class="xj-sort">-07-</div>
					</li>
				</ul>
				<div class="adv-tel">
					<span><i class="icon-phone-orange"></i>24小时服务热线：0755-82416002</span>
					<span>在线咨询 <i class="icon-wechat-white"></i></span>
				</div>
			</div>
		</div>

		<!-- 品牌实力 -->
		<div class="band-adv">
			<div class="contanier">
				<ul>
					<li>
						<h2>CUL TURE</h2>
						<p class="h2-p">品牌实力</p>
					</li>
					<li>
						<h3>勇于做小 微利是图</h3>
						<p>做别人不能做的事情，把每一件小事做好，做精，做深；
							宣堵每个环节漏洞，不简单追求利润最大化，而要追求
							客户价值的较大化。
						</p>
					</li>
					<li>
						<img src="../assets/image/s-xj.jpg" alt="">
					</li>
				</ul>
				<ul>
					<li>
						<h3>无微不至 服务入微</h3>
						<p>大处着眼，小处着手，莫以事小而不为
							服务由小见大，闪光出在细微处。
						</p>
					</li>

					<li>
						<img src="../assets/image/banner5.jpg" alt="">
					</li>
					<li>
						<h3>质量方针</h3>
						<p>诚信为本，顾客至上，优质高效；
							安全快捷，科学管理，精益求精。
						</p>
					</li>
				</ul>
				<ul>
					<li>
						<img src="../assets/image/s-c.jpg" alt="">
					</li>
					<li>
						<h3>团结协作 敢于创新</h3>
						<p>团结就是力量，合伙创业，合作创大业；
							创业是竞争，创新是发展，时时创新，处处创新。
						</p>
					</li>
					<li>
						<img src="../assets/image/s-r.jpg" alt="">
					</li>

				</ul>
			</div>
		</div>

		<!-- 先进设备 -->
		<div class="shebei">
			<div class="contanier">
				<div class="section-title">
					<h2>先进设备</h2>
					<p>拥有当今国内一线印前、印中及后道设备，满足不同客户的个性化需求</p>
				</div>
				<ul class="sb-list">
					<li>
						<img src="../assets/image/sb9.jpg" alt="">
<!--						<p>海德堡印刷机</p>-->
					</li>
					<li>
						<img src="../assets/image/sb10.jpg" alt="">
<!--						<p>全自动锁线机</p>-->
					</li>
					<li>
						<img src="../assets/image/sb11.jpg" alt="">
<!--						<p>配页机</p>-->
					</li>
					<li>
						<img src="../assets/image/sb12.jpg" alt="">
<!--						<p>折页机</p>-->
					</li>
				</ul>
				<ul class="sb-list">
					<li>
						<img src="../assets/image/sb1.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/sb2.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/sb3.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/sb4.jpg" alt="">
					</li>
				</ul>
				<ul class="sb-list">
					<li>
						<img src="../assets/image/sb5.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/sb6.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/sb7.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/sb8.jpg" alt="">
					</li>
				</ul>
			</div>
		</div>

		<!-- 合作伙伴 -->
		<div class="cooperate">
			<div class="contanier">
				<div class="section-title">
					<h2>合作伙伴</h2>
					<p>我们已成就了逾上万客户，众多政府机关、集团、民企指定认可画册印刷服务企业</p>
				</div>
				<ul>
					<li>
						<img src="../assets/image/c_1.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/c_2.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/c_3.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/c_4.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/c_5.jpg" alt="">
					</li>

					<li>
						<img src="../assets/image/c_6.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/c_7.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/c_8.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/c_9.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/c_10.jpg" alt="">
					</li>
				</ul>
			</div>
		</div>

		<!-- 新闻资讯 -->
		<div class="news" v-if="artilceLength">
			<div class="contanier">
				<div class="section-title">
					<h2>新闻资讯</h2>
					<p>了解行业最新资讯 了解印刷知识 服务更有保障</p>
				</div>
				<ul>
					<li v-for="item in artilces" v-bind:key="item.id">
						<router-link :to="{path:'/article',query:{id:item.id}}" class="a-item">
							<div class="new-img" v-if="item.img">
								<img :src="item.img" alt="图片未加载出来">
							</div>
							<div class="new-img" v-else>
								<img src="../assets/image/no.jpg">
							</div>
							<div class="news-info">
								<h2>{{item.title}}</h2>
								<div class="news-time">{{item.addtime}}</div>
								<div class="news-desc" v-html="item.description"></div>
							</div>
						</router-link>
					</li>
				</ul>
			</div>
		</div>

		<!-- 联系方式 -->
		<div class="contact">
			<div class="contanier">
				<div class="section-title">
					<h2>联系我们</h2>
					<p>7*24小时为您服务</p>
				</div>
				<ul>
					<li>
						<!-- <i class="icon-address-orange"></i> -->
						<img src="../assets/image/address.png" alt="">
						<h3>地址</h3>
						<p>深圳市龙岗区平湖街道禾花社区<br>
							同富路14号A栋2楼、3楼</p>
					</li>
					<li>
						<!-- <i class="icon-landline-orange"></i> -->
						<img src="../assets/image/phone.png" alt="">
						<h3>座机</h3>
						<p>0755-82416002</p>
					</li>
					<li>
						<!-- <i class="icon-phone-orange"></i> -->
						<img src="../assets/image/tel.png" alt="">
						<h3>手机</h3>
						<p>13411203329</p>
					</li>
					<li>
						<!-- <i class="icon-email-orange"></i> -->
						<img src="../assets/image/email.png" alt="">
						<h3>邮箱</h3>
						<p>sz82416002@126.com</p>
					</li>
				</ul>
			</div>
		</div>

	</div>
</template>

<script>
	import Swiper from 'swiper'
	import Certs from '../components/Certs.vue'
	import 'swiper/css/swiper.min.css'
	export default {
		components: {
			Certs
		},
		data: () => {
			return {
				artilces: [],
				artilceLength: 0
			}
		},
		mounted() {
			new Swiper('.swiper1', {
				loop: true,
				// 如果需要分页器
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				//如果需要自动切换海报
				autoplay: {
					delay: 5000, //时间 毫秒
					disableOnInteraction: false, //用户操作之后是否停止自动轮播默认true
				},
			})
			//获取服务器数据
			console.log(this);
			this.axios.get("getHomeArticle").then(res => {
				console.log(res);
				if (res.data.code == 'success') {
					this.artilces = res.data.data;
					this.artilceLength = res.data.data.length;
				}
			})
		}
	}
</script>

<style lang="less">
	@import '../assets/css/main.less';
	@import '../assets/css/home.less';
</style>
